import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

import { RefreshAccessFragment } from "../../models/autogenerated-deliveryService-gql/graphql";
import { authorizationHeaders } from "../../utils/graphqlHelper";

export const errorLink = (
  refreshAccess: () => Promise<RefreshAccessFragment | undefined>,
) => [
  onError(({ graphQLErrors, operation, forward }) => {
    if (!graphQLErrors) return forward(operation);

    const unauthenticatedError = graphQLErrors.find(
      (error) => error.extensions?.code === "AUTH_NOT_AUTHENTICATED",
    );

    if (!unauthenticatedError) return forward(operation);

    const { getContext, setContext } = operation;
    const context = getContext();

    setContext({
      ...context,
      headers: {
        ...context?.headers,
        _needsRefresh: true,
      },
    });

    return forward(operation);
  }),
  setContext(async (_, previousContext) => {
    if (!previousContext?.headers?._needsRefresh) return previousContext;

    const response = await refreshAccess();
    if (!response) return previousContext;

    return {
      ...previousContext,
      headers: {
        ...previousContext.headers,
        ...authorizationHeaders(response.accessToken),
        _needsRefresh: undefined, // Remove the _needsRefresh flag after refreshing
      },
    };
  }),
];
